interface InputState {
  left: boolean;
  right: boolean;
  shoot: boolean;
  bomb: boolean;
  toggleInvincible: boolean;
  jumpToStage1: boolean;
  jumpToStage2: boolean;
  jumpToStage3: boolean;
  jumpToStage4: boolean;
}

export class InputManager {
  private keys: { [key: string]: boolean } = {};
  private previousBomb: boolean = false;
  private previousInvincible: boolean = false;
  private previousStage1: boolean = false;
  private previousStage2: boolean = false;
  private previousStage3: boolean = false;
  private previousStage4: boolean = false;

  setup(): void {
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    window.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  private handleKeyDown(event: KeyboardEvent): void {
    this.keys[event.code] = true;
  }

  private handleKeyUp(event: KeyboardEvent): void {
    this.keys[event.code] = false;
  }

  getInput(): InputState {
    const shoot = this.keys['Space'] || this.keys['KeyZ'];
    
    const bomb = this.keys['KeyX'] || this.keys['KeyC'];
    const bombPressed = bomb && !this.previousBomb;
    this.previousBomb = bomb;

    const invincible = this.keys['KeyI'];
    const invinciblePressed = invincible && !this.previousInvincible;
    this.previousInvincible = invincible;

    const stage1 = this.keys['Digit1'];
    const stage1Pressed = stage1 && !this.previousStage1;
    this.previousStage1 = stage1;

    const stage2 = this.keys['Digit2'];
    const stage2Pressed = stage2 && !this.previousStage2;
    this.previousStage2 = stage2;

    const stage3 = this.keys['Digit3'];
    const stage3Pressed = stage3 && !this.previousStage3;
    this.previousStage3 = stage3;

    const stage4 = this.keys['Digit4'];
    const stage4Pressed = stage4 && !this.previousStage4;
    this.previousStage4 = stage4;

    return {
      left: this.keys['ArrowLeft'] || this.keys['KeyA'],
      right: this.keys['ArrowRight'] || this.keys['KeyD'],
      shoot: shoot, // 押しっぱなしで連射
      bomb: bombPressed,
      toggleInvincible: invinciblePressed,
      jumpToStage1: stage1Pressed,
      jumpToStage2: stage2Pressed,
      jumpToStage3: stage3Pressed,
      jumpToStage4: stage4Pressed
    };
  }
}